import prefetchChunks from 'EmailComponents/utils/prefetchChunks';
import { setupDeferredPrefetchingOfEditorAssets } from './editorPrefetcher';
export default prefetchChunks([() => setupDeferredPrefetchingOfEditorAssets()]);